export default "__VITE_ASSET__DH1Uee$4__"